import React from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// import JS files
import MuiButton from "../mui/MuiButton";

// import others files

const AddContainer = (props) => {
  return (
    <>
       <div className="flex justify-between items-center mt-8">
          <span className="text-myblack-100 text-sm md:text-base ml-2 md:ml-0 leading-7">
            {props.text}
          </span>
          <MuiButton
            onClick={() => props.onClick()}
            variant="contained"
                icon={<AddCircleOutlineIcon />}
            color="secondary"
            text="افزودن"
          />
        </div>
    </>
  );
};

export default AddContainer;
